import { render } from "./CrudCarreta.vue?vue&type=template&id=bc295ba2"
import script from "./CrudCarreta.vue?vue&type=script&lang=ts"
export * from "./CrudCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script